export default "__VITE_ASSET__DRRUrHI7__"